import React, { useMemo } from "react";
import EventTable from "./EventTable";
import EventCard from "./EventCard";
import EventsSummaryHeader from "./EventsSummaryHeader";
import LoadingSpinner from "../../../../revampComponents/Atom/Loading";
import PaymentStatsCard from "../PaymentAnalytics/PaymentStatsCard";
import { chartColorScheme } from "../AccountLevelReportConstant";
import Loading from "../../../../components/Loading";

const EventsSummary = ({
  eventStatus = "past",
  dateFilter = "lastWeek",
  viewType = "card",
  eventsList = [],
  eventsCount = 0,
  loading = false,
  onEventStatusChange = () => { },
  onDateFilterChange = () => { },
  onViewTypeChange = () => { },
  onPaginationChange = () => { },
  eventStatusOptions = [],
  dateFilterOptions = [],
  viewTypeOptions = [],
  paymentStatsData = { methods: [], gateways: [] },
  paymentLoading = false, 
  selectedCurrency = null,
  onCardPaginationChange
}) => {

  const eventsData = useMemo(() => {
    if (Array.isArray(eventsList)) {
      return eventsList;
    }
    if (eventsList?.events_summary && Array.isArray(eventsList?.events_summary)) {
      return eventsList?.events_summary;
    }
    return [];
  }, [eventsList]);

  // Handle initial table load - called when switching to table view
  const handleTableInitialLoad = (params) => {
    if (onPaginationChange) {
      onPaginationChange({
        ...params,
        isInitialTableLoad: true // Flag to indicate this is initial table load
      });
    }
  };

  // Handle pagination changes from EventTable
  const handlePaginationChange = (paginationParams) => {
    if (onPaginationChange) {
      onPaginationChange(paginationParams);
    }
  };

  // Handle download CSV
  const handleDownloadCSV = () => {
    if (eventsData?.length === 0) {
      return;
    }
  };

  const handleEventClick = (eventId) => {
    window.open(`/e/${eventId}`, "_blank");
  };

  return (
    <div className="events-summary-container">
      <EventsSummaryHeader
        eventStatus={eventStatus}
        dateFilter={dateFilter}
        viewType={viewType}
        eventsCount={eventsCount}
        onEventStatusChange={onEventStatusChange}
        onDateFilterChange={onDateFilterChange}
        onViewTypeChange={onViewTypeChange}
        onDownloadCSV={handleDownloadCSV}
        eventStatusOptions={eventStatusOptions}
        dateFilterOptions={dateFilterOptions}
      />


      <div className="report-events-content">
        {viewType === "card" ? (
          <EventCard
            events={eventsData}
            onEventClick={handleEventClick}
            loading={loading}
            eventStatus={eventStatus}
            dateFilter={dateFilter}
            selectedCurrency={selectedCurrency}
            totalCount={eventsCount}
            onCardPaginationChange={onCardPaginationChange}
          />
        ) : (
          <EventTable
            events={eventsData}
            totalCount={eventsCount}
            onEventClick={handleEventClick}
            loading={loading}
            eventStatus={eventStatus}
            dateFilter={dateFilter}
            onPaginationChange={handlePaginationChange}
            onInitialLoad={handleTableInitialLoad} // Pass initial load handler
              selectedCurrency={selectedCurrency}
          />
        )}
      {!loading && selectedCurrency?.currency_name === 'INR' &&  <div className=" row ml-0 mr-0 mt-4 mb-5 pb-4 payment-analytics-cont">
          <div className="col-md-6">
            <PaymentStatsCard
              title="Payment Methods Used"
              data={paymentStatsData?.methods}
              colorScheme={chartColorScheme}
            />
          </div>
          <div className="col-md-6">
            <PaymentStatsCard
              title="Payment Gateways Used"
               data={paymentStatsData?.gateways}
              colorScheme={chartColorScheme}
            />
          </div>
        </div>}
      </div>

      <style>{`
        .events-summary-container {
          background: white;
          border-radius: 8px;
          margin: 20px 0;
          box-shadow: 0px 0px 20px 9px #002E6E24;
          min-height: 400px;
        }

        .report-events-content {
          padding-bottom: 20px;
        }
        .payment-analytics-cont{
          padding: 0px 5px;
          row-gap: 15px;
        }
      `}</style>
    </div>
  );
};

export default EventsSummary;
